import React, { useState } from 'react';
import { Autocomplete } from "@react-google-maps/api";

const AddressCard = ({ address, setAddress, floor, setFloor, buttonDisabled, onLoad, onPlaceChanged }) => {
  const [addressFocused, setAddressFocused] = useState(false);
  const [floorFocused, setFloorFocused] = useState(false);

  return (
    <div style={styles.infoCard}>
      <div style={styles.cardTitle}>
        {buttonDisabled ? "Address" : "Complete Address"}
      </div>

      <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
        <input
          type="text"
          placeholder="Enter full address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          onFocus={() => setAddressFocused(true)}
          onBlur={() => setAddressFocused(false)}
          style={{
            ...styles.textArea,
            ...styles.inputCommon,
            borderColor: addressFocused ? 'var(--partner-primary)' : '#ccc',

          }}
        />
      </Autocomplete>

      <input
        type="text"
        placeholder="Apartment / House / Floor No."
        value={floor}
        onChange={(e) => setFloor(e.target.value)}
        onFocus={() => setFloorFocused(true)}
        onBlur={() => setFloorFocused(false)}
        style={{
          ...styles.input,
          ...styles.inputCommon,
          borderColor: addressFocused ? 'var(--partner-primary)' : '#ccc',

        }}
      />
    </div>
  );
};

const styles = {
  infoCard: {
    backgroundColor: "#fff",
    margin: "14px 10px",
    borderRadius: 20,
    padding: 16,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  cardTitle: {
    color: "#2E2E2E",
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "12px",
  },
  inputCommon: {
    border: '1px solid #ccc',
    borderRadius: 8,
    padding: '12px',
    fontSize: 14,
    fontWeight: "500",
    // letterSpacing: 1,
    marginTop: 10,
    width: '100%',
    color: '#000',
    outline: 'none',
  },
  textArea: {
    resize: 'vertical',
    minHeight: 70,
  },
  input: {
    height: 40,
  },
};

export default AddressCard;
